const GratefulNotification = `Oi _*{{CONTACT.NAME}}*_,

Olha eu aqui novamente! 🤭

Mas dessa vez para agradecer por ter respondido nossa pesquisa do projeto PEARLS! 🤩

Sua ajuda faz toda a diferença para nós e para muitas outras mulheres.

Muito obrigad{{USER.PREFIX}}!

_*{{USER.NAME}}*_ e _*Equipe Projeto PEARLS Brazil*_ _UNIFESP_`;

export { GratefulNotification };
